import cn from 'classnames'
import Link from 'next/link'
import { LYSTypography } from '@core/components/Primitives'
import routes from '@core/config/routes'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import style from './index.module.less'

interface Props {
  className: string
}

const BrandInfo: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const { product } = useProductDetailContext() || {}

  if (!product || !product.brand) {
    return null
  }

  const brandRoute = routes.brandDetail(product.brand.slug, product.brand.id)

  const brandInfo = product.brand.image ? (
    <img
      className={cn(className, style.brandInfo)}
      src={product.brand.image}
      alt={product.brand.name}
      height={20}
      width={100}
    />
  ) : (
    <div className={className}>
      <LYSTypography.Text className={style.textLink}>
        {t('productDetail.showMoreFromBrand', {
          brandName: product.brand.name,
        })}
      </LYSTypography.Text>
    </div>
  )

  return <Link {...brandRoute}>{brandInfo}</Link>
}

export default BrandInfo
